export default __webpack_public_path__ + "static/1041-8b47727065a1dd8e04bc50f60c14219b.gif";